import { normalizeFundingPercentage } from './pickLatestDeal';

export function suggestGrowthAmount({ marketingSpend, fundingPercentage }) {
  const fundingPct = normalizeFundingPercentage(fundingPercentage);
  const spend = Number(marketingSpend);
  if (!Number.isFinite(spend) || spend <= 0 || fundingPct == null) {
    return { suggestedAmount: null };
  }

  return {
    suggestedAmount: (spend * fundingPct) / 100,
  };
}

export function isGrowthInvestmentComplete(value) {
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0;
}
